// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 763 ? "classification" : chunkId) + "." + {"471":"b844e7da","656":"5f6ba6c8","763":"b955ae89","788":"058b8421","793":"5839c866","813":"9d32ef4e","889":"b37184e4","940":"ea97dc08"}[chunkId] + ".js";
};